import * as loadingAction from "../../store/loading/action";
import * as messageAction from "../../store/message/action";

import "react-drawer/lib/react-drawer.css";

import { Col, Row } from "reactstrap";
// Reactstrap
import { Dropdown, DropdownMenu, DropdownToggle, Button, } from "reactstrap";
import React, { Component } from "react";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import { Link } from "react-router-dom";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import PropTypes from "prop-types";
import ReactDrawer from "react-drawer";
import RightSidebar from "../CommonForBoth/RightSidebar";
import bitbucket from "../../assets/images/brands/bitbucket.png";
import { connect } from "react-redux";
import dribbble from "../../assets/images/brands/dribbble.png";
import dropbox from "../../assets/images/brands/dropbox.png";
// import images
import github from "../../assets/images/brands/github.png";
import logo from "../../assets/images/logo.svg";
import logoLightSvg from "../../assets/images/logo-light.svg";
import mail_chimp from "../../assets/images/brands/mail_chimp.png";
import megamenuImg from "../../assets/images/megamenu-img.png";
import slack from "../../assets/images/brands/slack.png";
// Redux Store
import { toggleRightSidebar } from "../../store/actions";
//i18n
import { withTranslation } from "react-i18next";
import OverButton from "../../components/Custom/Overbutton";
import { useDispatch } from "react-redux";
import {
  baseUrl,
} from "../../helpers/url_api_constant";
import { getPermission, getUserToken } from "../../helpers/auth_helper";
import moment from "moment";
import DownloadManual from "./DownloadManual";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearch: false,
      open: false,
      position: "right",
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleRightDrawer = this.toggleRightDrawer.bind(this);
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.onDrawerClose = this.onDrawerClose.bind(this);
  }

  componentDidMount() {
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", this.toggleMenu());
  }

  componentWillUnmount() {
    document
      .querySelector(`#vertical-menu-btn`)
      .removeEventListener("click", this.toggleMenu());
  }
  /**
   * Toggle sidebar
   */
  toggleMenu() {
    this.props.toggleMenuCallback();
  }
  /**
   * Right sidebar drawer
   * */

  toggleRightDrawer() {
    this.setState({ position: "right" });
    this.setState({ open: !this.state.open });
  }
  closeDrawer() {
    this.setState({ open: false });
  }
  onDrawerClose() {
    this.setState({ open: false });
  }

  /**
   * Toggles the sidebar
   */
  toggleRightbar() {
    this.props.toggleRightSidebar();
  }


  downloadPowerPoint(data) {
    // console.log(data);

    const date = moment(new Date()).format("DD.MM.YYYY");
    // dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/DownloadFile/DownloadFile?downloadData=" + data, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.ms-powerpoint',  //msword
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })

      .then((response) => {
        response.blob()
        // console.log(response);
      })

      .then((blob) => {
        // Create blob link to download
        // console.log(blob);
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          data + '_ENH-TSO Operation Report ' + date + '.pptx'
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        // dispatch(loadingAction.hideLoading());
      });
  };

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box d-lg-none d-md-block">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logo} alt="" height="22" />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoLightSvg} alt="" height="22" />
                  </span>
                </Link>
              </div>

              <span onClick={void(0)}>
                <button
                  type="button"
                  onClick={this.toggleMenu}
                  style={{ cursor: 'pointer' }}
                  className="btn btn-sm px-3 font-size-16 header-item"
                  id="vertical-menu-btn"
                >
                  <i className="fa fa-fw fa-bars"></i>
                </button>
              </span>

            </div>
            {process.env.REACT_APP_PRODUCTION_MODE != 1 && <h2> Server Test </h2>}

            <div className="d-flex">

              <DownloadManual />

              <ProfileMenu />
              <div className="dropdown d-none d-lg-inline-block ms-1">
                <button
                  type="button"
                  onClick={this.toggleFullscreen}
                  className="btn header-item noti-icon"
                  data-toggle="fullscreen"
                >
                  <i className="bx bx-fullscreen"></i>
                </button>
              </div>
            </div>

          </div>
        </header>
        <ReactDrawer
          open={this.state.open}
          position={this.state.position}
          onClose={this.onDrawerClose}
        >
          <RightSidebar onClose={this.onDrawerClose} />
        </ReactDrawer>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  const { layoutType } = state.Layout;
  return { layoutType };
};

export default connect(mapStatetoProps, { toggleRightSidebar })(
  withTranslation()(Header)
);

Header.propTypes = {
  t: PropTypes.any,
  toggleMenuCallback: PropTypes.any,
  toggleRightSidebar: PropTypes.func,
};
